import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4b061933 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _62f89413 = () => interopDefault(import('../pages/basket/index.vue' /* webpackChunkName: "pages/basket/index" */))
const _21be9f01 = () => interopDefault(import('../pages/cabinet/index.vue' /* webpackChunkName: "pages/cabinet/index" */))
const _291065c6 = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _64ec4b2e = () => interopDefault(import('../pages/cookie.vue' /* webpackChunkName: "pages/cookie" */))
const _72325f84 = () => interopDefault(import('../pages/delivery.vue' /* webpackChunkName: "pages/delivery" */))
const _339a122b = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _35971ce6 = () => interopDefault(import('../pages/giftcard/index.vue' /* webpackChunkName: "pages/giftcard/index" */))
const _3465970f = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4f73f2be = () => interopDefault(import('../pages/login_phone.vue' /* webpackChunkName: "pages/login_phone" */))
const _b5435958 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _1802807b = () => interopDefault(import('../pages/oferta.vue' /* webpackChunkName: "pages/oferta" */))
const _608cdaac = () => interopDefault(import('../pages/partnership.vue' /* webpackChunkName: "pages/partnership" */))
const _2213cefc = () => interopDefault(import('../pages/policy.vue' /* webpackChunkName: "pages/policy" */))
const _08e50fa4 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _9da2ecfa = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _9705d4ba = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _8cf1e890 = () => interopDefault(import('../pages/sizes.vue' /* webpackChunkName: "pages/sizes" */))
const _4facf146 = () => interopDefault(import('../pages/warranty.vue' /* webpackChunkName: "pages/warranty" */))
const _42c3d789 = () => interopDefault(import('../pages/basket/cancel.vue' /* webpackChunkName: "pages/basket/cancel" */))
const _c28655fc = () => interopDefault(import('../pages/basket/check-payment.vue' /* webpackChunkName: "pages/basket/check-payment" */))
const _2773edc5 = () => interopDefault(import('../pages/basket/no-found.vue' /* webpackChunkName: "pages/basket/no-found" */))
const _76c41a3b = () => interopDefault(import('../pages/basket/no-info.vue' /* webpackChunkName: "pages/basket/no-info" */))
const _2a6be484 = () => interopDefault(import('../pages/basket/success.vue' /* webpackChunkName: "pages/basket/success" */))
const _cc531af4 = () => interopDefault(import('../pages/cabinet/favorites.vue' /* webpackChunkName: "pages/cabinet/favorites" */))
const _9a74e15a = () => interopDefault(import('../pages/cart/fail.vue' /* webpackChunkName: "pages/cart/fail" */))
const _0ed0abb0 = () => interopDefault(import('../pages/catalog/search.vue' /* webpackChunkName: "pages/catalog/search" */))
const _0803a94f = () => interopDefault(import('../pages/giftcard/cancel.vue' /* webpackChunkName: "pages/giftcard/cancel" */))
const _7268987c = () => interopDefault(import('../pages/giftcard/check-payment.vue' /* webpackChunkName: "pages/giftcard/check-payment" */))
const _c7f333ea = () => interopDefault(import('../pages/giftcard/no-found.vue' /* webpackChunkName: "pages/giftcard/no-found" */))
const _597e8135 = () => interopDefault(import('../pages/giftcard/no-info.vue' /* webpackChunkName: "pages/giftcard/no-info" */))
const _0d264b7e = () => interopDefault(import('../pages/giftcard/success.vue' /* webpackChunkName: "pages/giftcard/success" */))
const _66f0595e = () => interopDefault(import('../pages/payment/fail.vue' /* webpackChunkName: "pages/payment/fail" */))
const _4f21a6a0 = () => interopDefault(import('../pages/payment/success.vue' /* webpackChunkName: "pages/payment/success" */))
const _6abdf3f8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _04662ad9 = () => interopDefault(import('../pages/catalog/collection/_slug.vue' /* webpackChunkName: "pages/catalog/collection/_slug" */))
const _0ea14dcc = () => interopDefault(import('../pages/catalog/product/_slug.vue' /* webpackChunkName: "pages/catalog/product/_slug" */))
const _42d47e3a = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4b061933,
    name: "about"
  }, {
    path: "/basket",
    component: _62f89413,
    name: "basket"
  }, {
    path: "/cabinet",
    component: _21be9f01,
    name: "cabinet"
  }, {
    path: "/contacts",
    component: _291065c6,
    name: "contacts"
  }, {
    path: "/cookie",
    component: _64ec4b2e,
    name: "cookie"
  }, {
    path: "/delivery",
    component: _72325f84,
    name: "delivery"
  }, {
    path: "/forgot-password",
    component: _339a122b,
    name: "forgot-password"
  }, {
    path: "/giftcard",
    component: _35971ce6,
    name: "giftcard"
  }, {
    path: "/login",
    component: _3465970f,
    name: "login"
  }, {
    path: "/login_phone",
    component: _4f73f2be,
    name: "login_phone"
  }, {
    path: "/logout",
    component: _b5435958,
    name: "logout"
  }, {
    path: "/oferta",
    component: _1802807b,
    name: "oferta"
  }, {
    path: "/partnership",
    component: _608cdaac,
    name: "partnership"
  }, {
    path: "/policy",
    component: _2213cefc,
    name: "policy"
  }, {
    path: "/privacy",
    component: _08e50fa4,
    name: "privacy"
  }, {
    path: "/registration",
    component: _9da2ecfa,
    name: "registration"
  }, {
    path: "/reset-password",
    component: _9705d4ba,
    name: "reset-password"
  }, {
    path: "/sizes",
    component: _8cf1e890,
    name: "sizes"
  }, {
    path: "/warranty",
    component: _4facf146,
    name: "warranty"
  }, {
    path: "/basket/cancel",
    component: _42c3d789,
    name: "basket-cancel"
  }, {
    path: "/basket/check-payment",
    component: _c28655fc,
    name: "basket-check-payment"
  }, {
    path: "/basket/no-found",
    component: _2773edc5,
    name: "basket-no-found"
  }, {
    path: "/basket/no-info",
    component: _76c41a3b,
    name: "basket-no-info"
  }, {
    path: "/basket/success",
    component: _2a6be484,
    name: "basket-success"
  }, {
    path: "/cabinet/favorites",
    component: _cc531af4,
    name: "cabinet-favorites"
  }, {
    path: "/cart/fail",
    component: _9a74e15a,
    name: "cart-fail"
  }, {
    path: "/catalog/search",
    component: _0ed0abb0,
    name: "catalog-search"
  }, {
    path: "/giftcard/cancel",
    component: _0803a94f,
    name: "giftcard-cancel"
  }, {
    path: "/giftcard/check-payment",
    component: _7268987c,
    name: "giftcard-check-payment"
  }, {
    path: "/giftcard/no-found",
    component: _c7f333ea,
    name: "giftcard-no-found"
  }, {
    path: "/giftcard/no-info",
    component: _597e8135,
    name: "giftcard-no-info"
  }, {
    path: "/giftcard/success",
    component: _0d264b7e,
    name: "giftcard-success"
  }, {
    path: "/payment/fail",
    component: _66f0595e,
    name: "payment-fail"
  }, {
    path: "/payment/success",
    component: _4f21a6a0,
    name: "payment-success"
  }, {
    path: "/",
    component: _6abdf3f8,
    name: "index"
  }, {
    path: "/catalog/collection/:slug?",
    component: _04662ad9,
    name: "catalog-collection-slug"
  }, {
    path: "/catalog/product/:slug?",
    component: _0ea14dcc,
    name: "catalog-product-slug"
  }, {
    path: "/catalog/:slug?",
    component: _42d47e3a,
    name: "catalog-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
